module.exports = function() {
  return new Worker(__webpack_public_path__ + "js/wasm-module-2.bcfd83521ce3a28bc47e.js");
};